/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Confidence_LowInputs */

const en_directory_agent_readiness_confidence_low = /** @type {(inputs: Directory_Agent_Readiness_Confidence_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low confidence`)
};

const zh_directory_agent_readiness_confidence_low = /** @type {(inputs: Directory_Agent_Readiness_Confidence_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低置信度`)
};

/**
* | output |
* | --- |
* | "Low confidence" |
*
* @param {Directory_Agent_Readiness_Confidence_LowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_confidence_low = /** @type {((inputs?: Directory_Agent_Readiness_Confidence_LowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Confidence_LowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_confidence_low(inputs)
	return zh_directory_agent_readiness_confidence_low(inputs)
});
export { directory_agent_readiness_confidence_low as "directory.agent_readiness.confidence.low" }